/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Banner_Mobile_Preview_HintInputs */



/**
* | output |
* | --- |
* | "Square preview — how chat apps and mobile feeds crop it." |
*
* @param {Banner_Mobile_Preview_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const banner_mobile_preview_hint = /** @type {((inputs?: Banner_Mobile_Preview_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Banner_Mobile_Preview_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aperçu carré — recadrage appliqué par les messageries et fils mobiles.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa cuadrada — cómo la recortan las apps de mensajería y los feeds móviles.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pré-visualização quadrada — como apps de mensagens e feeds móveis recortam a imagem.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima quadrata — come le app di messaggistica e i feed mobili la ritagliano.")
	return /** @type {LocalizedString} */ ("Square preview — how chat apps and mobile feeds crop it.")
});